import * as React from 'react'
import { Card, CardHeader, CardContent, Button, Box } from '@mui/material'
import { useCurrentUserRedirectResource } from 'infrastructure/auth/auth.hooks'

export function LoginPage() {
  const { reFreshUser } = useCurrentUserRedirectResource()

  return (
    <Card>
      <CardHeader title="Need to Log In" />
      <CardContent>
        <Box>
          You must be logged in to the web app with an account that has admin
          access
        </Box>
        <Box>
          <Button variant="contained" color="primary" onClick={reFreshUser}>
            Try Now
          </Button>
        </Box>
      </CardContent>
    </Card>
  )
}
